
// import React, { useEffect, useRef, useState } from "react";
// import {
//   FiArrowUpRight,
//   FiMail,
//   FiPhone,
//   FiClock,
//   FiInstagram,
//   FiLinkedin,
//   FiFacebook,
//   FiArrowUp,
//   FiChevronRight,
// } from "react-icons/fi";

// const Footer = () => {
//   const footerRef = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (footerRef.current) {
//       observer.observe(footerRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);



//   const navigation = [
//     { name: "Home", href: "#home" },
//     { name: "About", href: "#About" },
//     { name: "Team", href: "#Team" },
//     { name: "What We Do", href: "#whatwedo" },
//     { name: "Services", href: "#Services" },
//     { name: "Contact", href: "#Contact" },
//   ];

//   const services = [
//     "Quantity Takeoffs",
//     "Construction Estimating",
//     "Material Takeoffs",
//     "Bid Preparation",
//     "Cost Analysis",
//     "Preconstruction Support",
//   ];

//   const divisions = [
//     "Division 01 — General Requirements",
//     "Division 02 — Existing Conditions",
//     "Division 03 — Concrete",
//     "Division 04 — Masonry",
//     "Division 05 — Metals",
//     "Division 07 — Thermal & Moisture",
//     "Division 08 — Openings",
//     "Division 09 — Finishes",
//     "Division 32 — Exterior Improvements",
//   ];

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
//     <>
//       <style>{`

//         /* =====================================================
//            FOOTER
//         ===================================================== */

//         .sg-footer {
//           position: relative;

//           overflow: hidden;

//           background:
//             linear-gradient(
//               135deg,
//               #0d2746 0%,
//               #123c68 55%,
//               #164d83 100%
//             );

//           color: #ffffff;
//         }

//         .sg-footer-container {
//           position: relative;

//           z-index: 3;

//           width: min(1380px, 92%);

//           margin: auto;
//         }

//         /* =====================================================
//            BLUEPRINT BACKGROUND
//         ===================================================== */

//         .sg-footer-blueprint {
//           position: absolute;

//           right: -120px;
//           bottom: -260px;

//           width: 720px;
//           height: 720px;

//           opacity: 0.18;

//           background-image:
//             linear-gradient(
//               rgba(255,255,255,0.08) 1px,
//               transparent 1px
//             ),
//             linear-gradient(
//               90deg,
//               rgba(255,255,255,0.08) 1px,
//               transparent 1px
//             );

//           background-size: 38px 38px;

//           transform: rotate(7deg);

//           pointer-events: none;
//         }

//         .sg-footer-circle-one {
//           position: absolute;

//           width: 460px;
//           height: 460px;

//           right: -220px;
//           top: -250px;

//           border: 1px solid rgba(255,255,255,0.08);

//           border-radius: 50%;
//         }

//         .sg-footer-circle-two {
//           position: absolute;

//           width: 310px;
//           height: 310px;

//           right: -145px;
//           top: -175px;

//           border: 1px dashed rgba(255,255,255,0.08);

//           border-radius: 50%;
//         }

//         /* =====================================================
//            TOP CTA
//         ===================================================== */

//         .sg-footer-cta {
//           position: relative;

//           display: flex;

//           align-items: center;

//           justify-content: space-between;

//           gap: 35px;

//           padding: 65px 0;

//           border-bottom: 1px solid rgba(255,255,255,0.11);

//           opacity: 0;

//           transform: translateY(25px);

//           transition:
//             opacity 0.75s ease,
//             transform 0.75s ease;
//         }

//         .sg-footer-cta.visible {
//           opacity: 1;

//           transform: translateY(0);
//         }

//         .sg-footer-cta-label {
//           display: flex;

//           align-items: center;

//           gap: 8px;

//           color: #f7a62c;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 1.5px;

//           text-transform: uppercase;
//         }

//         .sg-footer-cta-dot {
//           width: 7px;
//           height: 7px;

//           border-radius: 50%;

//           background: #f7a62c;
//         }

//         .sg-footer-cta-title {
//           margin: 10px 0 0;

//           color: #ffffff;

//           font-size: clamp(30px, 3.5vw, 48px);

//           line-height: 1.08;

//           letter-spacing: -1.8px;

//           font-weight: 800;
//         }

//         .sg-footer-cta-title span {
//           color: #8fc1ff;
//         }

//         .sg-footer-cta-text {
//           max-width: 620px;

//           margin: 10px 0 0;

//           color: rgba(255,255,255,0.60);

//           font-size: 12px;

//           line-height: 1.7;
//         }

//         .sg-footer-cta-button {
//           display: inline-flex;

//           align-items: center;

//           justify-content: center;

//           gap: 9px;

//           min-height: 51px;

//           padding: 0 23px;

//           flex-shrink: 0;

//           border-radius: 8px;

//           color: #153b68;

//           background: #ffffff;

//           text-decoration: none;

//           font-size: 10px;

//           font-weight: 900;

//           letter-spacing: 0.4px;

//           box-shadow:
//             0 15px 35px rgba(0,0,0,0.13);

//           transition:
//             transform 0.25s ease,
//             box-shadow 0.25s ease;
//         }

//         .sg-footer-cta-button:hover {
//           transform: translateY(-3px);

//           box-shadow:
//             0 20px 40px rgba(0,0,0,0.20);
//         }

//         .sg-footer-cta-button span {
//           color: #1558c0;

//           font-size: 14px;
//         }

//         /* =====================================================
//            MAIN FOOTER
//         ===================================================== */

//         .sg-footer-main {
//           display: grid;

//           grid-template-columns:
//             1.25fr
//             0.7fr
//             0.9fr
//             1.35fr;

//           gap: 55px;

//           padding: 65px 0 60px;

//           opacity: 0;

//           transform: translateY(25px);

//           transition:
//             opacity 0.75s ease 0.12s,
//             transform 0.75s ease 0.12s;
//         }

//         .sg-footer-main.visible {
//           opacity: 1;

//           transform: translateY(0);
//         }

//         /* =====================================================
//            BRAND
//         ===================================================== */

//         .sg-footer-brand {
//           max-width: 320px;
//         }

//         .sg-footer-logo {
//           display: inline-flex;

//           align-items: center;

//           gap: 11px;

//           text-decoration: none;

//           color: #ffffff;
//         }

//         .sg-footer-logo-mark {
//           position: relative;

//           width: 42px;
//           height: 42px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border: 2px solid rgba(255,255,255,0.88);

//           border-radius: 9px;

//           font-size: 18px;

//           font-weight: 900;
//         }

//         .sg-footer-logo-mark::after {
//           content: "";

//           position: absolute;

//           right: -4px;
//           bottom: -4px;

//           width: 11px;
//           height: 11px;

//           border-radius: 3px;

//           background: #f39818;

//           border: 2px solid #123b66;
//         }

//         .sg-footer-logo-name {
//           display: block;

//           color: #ffffff;

//           font-size: 17px;

//           font-weight: 900;

//           letter-spacing: -0.3px;
//         }

//         .sg-footer-logo-sub {
//           display: block;

//           margin-top: 3px;

//           color: rgba(255,255,255,0.48);

//           font-size: 7.5px;

//           font-weight: 700;

//           letter-spacing: 1.1px;

//           text-transform: uppercase;
//         }

//         .sg-footer-brand-text {
//           margin: 22px 0 0;

//           color: rgba(255,255,255,0.58);

//           font-size: 11px;

//           line-height: 1.8;
//         }

//         /* =====================================================
//            SOCIAL
//         ===================================================== */

//         .sg-footer-socials {
//           display: flex;

//           gap: 8px;

//           margin-top: 24px;
//         }

//         .sg-footer-social {
//           width: 35px;
//           height: 35px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border: 1px solid rgba(255,255,255,0.14);

//           border-radius: 8px;

//           color: rgba(255,255,255,0.75);

//           background: rgba(255,255,255,0.055);

//           text-decoration: none;

//           font-size: 11px;

//           font-weight: 800;

//           transition:
//             background 0.25s ease,
//             color 0.25s ease,
//             transform 0.25s ease;
//         }

//         .sg-footer-social:hover {
//           transform: translateY(-3px);

//           color: #ffffff;

//           background: rgba(255,255,255,0.13);
//         }

//         /* =====================================================
//            FOOTER COLUMNS
//         ===================================================== */

//         .sg-footer-column-title {
//           margin: 0 0 20px;

//           color: #ffffff;

//           font-size: 11px;

//           font-weight: 800;

//           letter-spacing: 0.8px;

//           text-transform: uppercase;
//         }

//         .sg-footer-links {
//           display: flex;

//           flex-direction: column;

//           gap: 11px;

//           margin: 0;

//           padding: 0;

//           list-style: none;
//         }

//         .sg-footer-links a {
//           display: inline-flex;

//           align-items: center;

//           gap: 7px;

//           color: rgba(255,255,255,0.55);

//           text-decoration: none;

//           font-size: 10px;

//           line-height: 1.4;

//           transition:
//             color 0.2s ease,
//             transform 0.2s ease;
//         }

//        .sg-footer-link-icon {
//   width: 12px;
//   height: 12px;
//   flex-shrink: 0;

//   opacity: 0;
//   color: #f39818;

//   transform: translateX(-4px);

//   transition:
//     opacity 0.2s ease,
//     transform 0.2s ease;
// }

// .sg-footer-links a:hover .sg-footer-link-icon {
//   opacity: 1;
//   transform: translateX(0);
// }

//         /* =====================================================
//            DIVISIONS
//         ===================================================== */

//         .sg-footer-division {
//           display: flex;

//           align-items: flex-start;

//           gap: 8px;

//           color: rgba(255,255,255,0.52);

//           font-size: 8.5px;

//           line-height: 1.45;
//         }

//         .sg-footer-division-number {
//           min-width: 22px;

//           color: #8fc1ff;

//           font-size: 8px;

//           font-weight: 900;
//         }

//         /* =====================================================
//            CONTACT
//         ===================================================== */

//         .sg-footer-contact-list {
//           display: flex;

//           flex-direction: column;

//           gap: 17px;
//         }

//         .sg-footer-contact {
//           display: flex;

//           align-items: flex-start;

//           gap: 11px;
//         }

//         .sg-footer-contact-icon {
//           width: 32px;
//           height: 32px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 7px;

//           color: #ffffff;

//           background: rgba(255,255,255,0.08);

//           font-size: 12px;
//         }

//         .sg-footer-contact strong {
//           display: block;

//           margin-bottom: 4px;

//           color: #ffffff;

//           font-size: 9px;

//           font-weight: 800;
//         }

//         .sg-footer-contact a,
//         .sg-footer-contact span {
//           color: rgba(255,255,255,0.52);

//           font-size: 9px;

//           line-height: 1.5;

//           text-decoration: none;
//         }

//         .sg-footer-contact a:hover {
//           color: #ffffff;
//         }

//         /* =====================================================
//            BOTTOM BAR
//         ===================================================== */

//         .sg-footer-bottom {
//           display: flex;

//           align-items: center;

//           justify-content: space-between;

//           gap: 25px;

//           padding: 21px 0;

//           border-top: 1px solid rgba(255,255,255,0.10);

//           opacity: 0;

//           transform: translateY(15px);

//           transition:
//             opacity 0.7s ease 0.22s,
//             transform 0.7s ease 0.22s;
//         }

//         .sg-footer-bottom.visible {
//           opacity: 1;

//           transform: translateY(0);
//         }

//         .sg-footer-copyright {
//           color: rgba(255,255,255,0.40);

//           font-size: 8.5px;
//         }

//         .sg-footer-legal {
//           display: flex;

//           align-items: center;

//           gap: 20px;
//         }

//         .sg-footer-legal a {
//           color: rgba(255,255,255,0.40);

//           text-decoration: none;

//           font-size: 8.5px;

//           transition: color 0.2s ease;
//         }

//         .sg-footer-legal a:hover {
//           color: #ffffff;
//         }

//         /* =====================================================
//            BACK TO TOP
//         ===================================================== */

//         .sg-footer-top {
//           width: 35px;
//           height: 35px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border: 1px solid rgba(255,255,255,0.14);

//           border-radius: 8px;

//           color: #ffffff;

//           background: rgba(255,255,255,0.05);

//           font-size: 14px;

//           cursor: pointer;

//           transition:
//             background 0.25s ease,
//             transform 0.25s ease;
//         }

//         .sg-footer-top:hover {
//           transform: translateY(-3px);

//           background: rgba(255,255,255,0.13);
//         }
// .sg-footer-cta-icon {
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .sg-footer-cta-icon svg {
//   width: 16px;
//   height: 16px;
//   stroke-width: 2.5;
// }

// .sg-footer-social svg {
//   width: 16px;
//   height: 16px;
//   stroke-width: 2;
// }
//   .sg-footer-contact-icon svg {
//   width: 15px;
//   height: 15px;
//   stroke-width: 2;
// }

// .sg-footer-top svg {
//   width: 16px;
//   height: 16px;
//   stroke-width: 2.2;
// }
//         /* =====================================================
//            TABLET
//         ===================================================== */

//         @media (max-width: 1050px) {

//           .sg-footer-main {
//             grid-template-columns:
//               1fr 1fr;

//             gap: 45px;
//           }

//           .sg-footer-brand {
//             max-width: 430px;
//           }
//         }

//         /* =====================================================
//            MOBILE
//         ===================================================== */

//         @media (max-width: 760px) {

//           .sg-footer-cta {
//             display: block;

//             padding: 55px 0;

//             text-align: center;
//           }

//           .sg-footer-cta-label {
//             justify-content: center;
//           }

//           .sg-footer-cta-text {
//             margin-left: auto;
//             margin-right: auto;
//           }

//           .sg-footer-cta-button {
//             width: 100%;

//             margin-top: 24px;
//           }

//           .sg-footer-main {
//             grid-template-columns: 1fr;

//             gap: 38px;

//             padding: 50px 0;
//           }

//           .sg-footer-brand {
//             max-width: 550px;
//           }

//           .sg-footer-bottom {
//             display: block;

//             text-align: center;
//           }

//           .sg-footer-legal {
//             justify-content: center;

//             margin-top: 13px;
//           }

//           .sg-footer-top {
//             margin: 18px auto 0;
//           }
//         }

//         /* =====================================================
//            SMALL MOBILE
//         ===================================================== */

//         @media (max-width: 480px) {

//           .sg-footer-cta-title {
//             font-size: 30px;

//             letter-spacing: -1px;
//           }

//           .sg-footer-main {
//             gap: 35px;
//           }

//           .sg-footer-legal {
//             gap: 13px;
//           }

//         }

//       `}</style>


//       <footer
//         className="sg-footer"
//         ref={footerRef}
//       >

//         {/* BACKGROUND */}

//         <div className="sg-footer-blueprint"></div>

//         <div className="sg-footer-circle-one"></div>

//         <div className="sg-footer-circle-two"></div>


//         <div className="sg-footer-container">

//           {/* =================================================
//               CTA
//           ================================================= */}

//           <div
//             className={`sg-footer-cta ${visible ? "visible" : ""
//               }`}
//           >

//             <div>

//               <div className="sg-footer-cta-label">

//                 <span className="sg-footer-cta-dot"></span>

//                 Ready to Estimate?

//               </div>

//               <h2 className="sg-footer-cta-title">
//                 Your next bid starts
//                 <span> with the numbers.</span>
//               </h2>

//               <p className="sg-footer-cta-text">
//                 Send your project drawings and requirements to
//                 StructGuard Construction Services LLP and let
//                 our estimating team help you understand the
//                 cost behind your next project.
//               </p>

//             </div>


//             <a
//               href="#contact"
//               className="sg-footer-cta-button"
//             >
//               REQUEST AN ESTIMATE

//               <span>
//                 <FiArrowUpRight />
//               </span>

//             </a>

//           </div>


//           {/* =================================================
//               MAIN FOOTER
//           ================================================= */}

//           <div
//             className={`sg-footer-main ${visible ? "visible" : ""
//               }`}
//           >

//             {/* =================================================
//                 BRAND
//             ================================================= */}

//             <div className="sg-footer-brand">

//               <a
//                 href="#home"
//                 className="sg-footer-logo"
//               >

//                 <div className="sg-footer-logo-mark">
//                   SG
//                 </div>

//                 <div>

//                   <span className="sg-footer-logo-name">
//                     StructGuard
//                   </span>

//                   <span className="sg-footer-logo-sub">
//                     Construction Services LLP
//                   </span>

//                 </div>

//               </a>


//               <p className="sg-footer-brand-text">
//                 Professional construction estimating support
//                 built around accurate quantity takeoffs,
//                 organized cost information, and dependable
//                 bid preparation.
//               </p>


//               <div className="sg-footer-socials">

//                 <a
//                   href="#"
//                   className="sg-footer-social"
//                   aria-label="LinkedIn"
//                 >
//                   <FiLinkedin />
//                 </a>

//                 <a
//                   href="#"
//                   className="sg-footer-social"
//                   aria-label="Facebook"
//                 >
//                   <FiFacebook />
//                 </a>

//                 <a
//                   href="#"
//                   className="sg-footer-social"
//                   aria-label="Instagram"
//                 >
//                   <FiInstagram />
//                 </a>

//               </div>

//             </div>


//             {/* =================================================
//                 NAVIGATION
//             ================================================= */}

//             <div>

//               <h3 className="sg-footer-column-title">
//                 Navigation
//               </h3>

//               <ul className="sg-footer-links">

//                 {navigation.map((item) => (

//                   <li key={item.name}>

//                     <a href={item.href}>
//                       <FiChevronRight className="sg-footer-link-icon" />
//                       {item.name}
//                     </a>
//                   </li>

//                 ))}

//               </ul>

//             </div>


//             {/* =================================================
//                 SERVICES
//             ================================================= */}

//             <div>

//               <h3 className="sg-footer-column-title">
//                 Services
//               </h3>

//               <ul className="sg-footer-links">

//                 {services.map((service) => (

//                   <li key={service}>

//                     <a href="#services">
//                       <FiChevronRight className="sg-footer-link-icon" />
//                       {service}
//                     </a>

//                   </li>

//                 ))}

//               </ul>

//             </div>


//             {/* =================================================
//                 CONTACT + DIVISIONS
//             ================================================= */}

//             <div>

//               <h3 className="sg-footer-column-title">
//                 Contact
//               </h3>

//               <div className="sg-footer-contact-list">

//                 <div className="sg-footer-contact">

//                   <div className="sg-footer-contact-icon">
//                     <FiMail />
//                   </div>

//                   <div>

//                     <strong>
//                       Email
//                     </strong>

//                     <a href="mailto:estimates@structguard.co.in">
//                       estimates@structguard.co.in
//                     </a>

//                   </div>

//                 </div>


//                 <div className="sg-footer-contact">

//                   <div className="sg-footer-contact-icon">
//                     <FiPhone />
//                   </div>

//                   <div>

//                     <strong>
//                       Phone
//                     </strong>

//                     <a href="tel:+10000000000">
//                       +1 (000) 000-0000
//                     </a>

//                   </div>

//                 </div>


//                 <div className="sg-footer-contact">

//                   <div className="sg-footer-contact-icon">
//                     <FiClock />
//                   </div>

//                   <div>

//                     <strong>
//                       Estimating
//                     </strong>

//                     <span>
//                       Project-based support
//                     </span>

//                   </div>

//                 </div>

//               </div>


//               {/* DIVISION MINI LIST */}

//               {/* <div
//                 style={{
//                   marginTop: "28px",
//                   paddingTop: "20px",
//                   borderTop:
//                     "1px solid rgba(255,255,255,0.08)",
//                 }}
//               >

//                 <h3 className="sg-footer-column-title">
//                   CSI Coverage
//                 </h3>

//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "6px",
//                   }}
//                 >

//                   {divisions.slice(0, 5).map(
//                     (division) => {

//                       const [number, ...rest] =
//                         division.split(" — ");

//                       return (
//                         <div
//                           className="sg-footer-division"
//                           key={division}
//                         >

//                           <span
//                             className="sg-footer-division-number"
//                           >
//                             {number}
//                           </span>

//                           <span>
//                             {rest.join(" — ")}
//                           </span>

//                         </div>
//                       );

//                     }
//                   )}

//                 </div>

//               </div> */}

//             </div>

//           </div>


//           {/* =================================================
//               BOTTOM
//           ================================================= */}

//           <div
//             className={`sg-footer-bottom ${visible ? "visible" : ""
//               }`}
//           >

//             <div className="sg-footer-copyright">
//               © {new Date().getFullYear()} StructGuard
//               Construction Services LLP. All rights reserved.
//             </div>


//             <div className="sg-footer-legal">

//               <a href="#">
//                 Privacy Policy
//               </a>

//               <a href="#">
//                 Terms & Conditions
//               </a>

//               <button
//                 className="sg-footer-top"
//                 onClick={scrollToTop}
//                 aria-label="Back to top"
//               >
//                 <FiArrowUp />
//               </button>

//             </div>

//           </div>

//         </div>

//       </footer>
//     </>
//   );
// };

// export default Footer;



import React, { useEffect, useRef, useState } from "react";
import {
  FiArrowUpRight,
  FiMail,
  FiPhone,
  FiClock,
  FiInstagram,
  FiLinkedin,
  FiFacebook,
  FiArrowUp,
  FiChevronRight,
  FiCheckCircle,
  FiLayers,
  FiPenTool,
  FiBox,
  FiSettings,
} from "react-icons/fi";

const Footer = () => {
  const footerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  /* =========================================================
     NAVIGATION
  ========================================================= */

  const navigation = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#About" },
    { name: "Team", href: "#Team" },
    { name: "What We Do", href: "#whatwedo" },
    { name: "Services", href: "#Services" },
    { name: "Contact", href: "#Contact" },
  ];

  /* =========================================================
     CORE SERVICES
  ========================================================= */

  const services = [
    {
      name: "Pre-Construction Services",
      href: "#preconstruction",
    },
    {
      name: "Estimating & Takeoffs",
      href: "#estimating",
    },
    {
      name: "Structural Engineering",
      href: "#structural-engineering",
    },
    {
      name: "BIM Services",
      href: "#bim",
    },
    {
      name: "Project Engineering",
      href: "#project-engineering",
    },
    {
      name: "Construction Support",
      href: "#construction-support",
    },
  ];

  /* =========================================================
     SERVICE CAPABILITIES
  ========================================================= */

  const capabilities = [
    "Quantity Takeoffs",
    "Construction Estimating",
    "Cost Analysis",
    "Bid Preparation",
    "CFS Engineering",
    "Structural Design",
    "BIM Modeling",
    "Project Coordination",
  ];

  /* =========================================================
     CSI DIVISIONS
  ========================================================= */

  const divisions = [
    "Division 01 — General Requirements",
    "Division 02 — Existing Conditions",
    "Division 03 — Concrete",
    "Division 04 — Masonry",
    "Division 05 — Metals",
    "Division 07 — Thermal & Moisture",
    "Division 08 — Openings",
    "Division 09 — Finishes",
    "Division 32 — Exterior Improvements",
  ];

  /* =========================================================
     BACK TO TOP
  ========================================================= */

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <style>{`

        /* =====================================================
           FOOTER
        ===================================================== */

        .sg-footer {
          position: relative;
          overflow: hidden;

          background:
            linear-gradient(
              135deg,
              #0b213b 0%,
              #10365c 52%,
              #164d83 100%
            );

          color: #ffffff;
        }

        .sg-footer-container {
          position: relative;
          z-index: 3;

          width: min(1380px, 92%);
          margin: auto;
        }

        /* =====================================================
           BLUEPRINT BACKGROUND
        ===================================================== */

        .sg-footer-blueprint {
          position: absolute;

          right: -120px;
          bottom: -260px;

          width: 720px;
          height: 720px;

          opacity: 0.18;

          background-image:
            linear-gradient(
              rgba(255,255,255,0.08) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(255,255,255,0.08) 1px,
              transparent 1px
            );

          background-size: 38px 38px;

          transform: rotate(7deg);

          pointer-events: none;
        }

        .sg-footer-circle-one {
          position: absolute;

          width: 460px;
          height: 460px;

          right: -220px;
          top: -250px;

          border: 1px solid rgba(255,255,255,0.08);

          border-radius: 50%;

          pointer-events: none;
        }

        .sg-footer-circle-two {
          position: absolute;

          width: 310px;
          height: 310px;

          right: -145px;
          top: -175px;

          border: 1px dashed rgba(255,255,255,0.08);

          border-radius: 50%;

          pointer-events: none;
        }

        /* =====================================================
           TOP CTA
        ===================================================== */

        .sg-footer-cta {
          position: relative;

          display: flex;

          align-items: center;
          justify-content: space-between;

          gap: 35px;

          padding: 65px 0;

          border-bottom:
            1px solid rgba(255,255,255,0.11);

          opacity: 0;

          transform: translateY(25px);

          transition:
            opacity 0.75s ease,
            transform 0.75s ease;
        }

        .sg-footer-cta.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-footer-cta-label {
          display: flex;

          align-items: center;

          gap: 8px;

          color: #f7a62c;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }

        .sg-footer-cta-dot {
          width: 7px;
          height: 7px;

          border-radius: 50%;

          background: #f7a62c;

          box-shadow:
            0 0 0 5px rgba(247,166,44,0.08);
        }

        .sg-footer-cta-title {
          margin: 10px 0 0;

          color: #ffffff;

          font-size: clamp(30px, 3.5vw, 48px);

          line-height: 1.08;

          letter-spacing: -1.8px;

          font-weight: 800;
        }

        .sg-footer-cta-title span {
          color: #8fc1ff;
        }

        .sg-footer-cta-text {
          max-width: 650px;

          margin: 12px 0 0;

          color: rgba(255,255,255,0.62);

          font-size: 12px;

          line-height: 1.75;
        }

        .sg-footer-cta-button {
          display: inline-flex;

          align-items: center;
          justify-content: center;

          gap: 9px;

          min-height: 52px;

          padding: 0 25px;

          flex-shrink: 0;

          border-radius: 8px;

          color: #153b68;

          background: #ffffff;

          text-decoration: none;

          font-size: 10px;

          font-weight: 900;

          letter-spacing: 0.5px;

          box-shadow:
            0 15px 35px rgba(0,0,0,0.13);

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            background 0.25s ease;
        }

        .sg-footer-cta-button:hover {
          transform: translateY(-3px);

          background: #f7a62c;

          color: #102f50;

          box-shadow:
            0 20px 40px rgba(0,0,0,0.20);
        }

        .sg-footer-cta-button span {
          display: flex;

          color: #1558c0;

          font-size: 14px;

          transition:
            color 0.25s ease;
        }

        .sg-footer-cta-button:hover span {
          color: #102f50;
        }

        /* =====================================================
           MAIN FOOTER
        ===================================================== */

        .sg-footer-main {
          display: grid;

          grid-template-columns:
            1.25fr
            0.75fr
            1.05fr
            1.15fr;

          gap: 48px;

          padding: 65px 0 60px;

          opacity: 0;

          transform: translateY(25px);

          transition:
            opacity 0.75s ease 0.12s,
            transform 0.75s ease 0.12s;
        }

        .sg-footer-main.visible {
          opacity: 1;

          transform: translateY(0);
        }

        /* =====================================================
           BRAND
        ===================================================== */

        .sg-footer-brand {
          max-width: 330px;
        }

        .sg-footer-logo {
          display: inline-flex;

          align-items: center;

          gap: 11px;

          text-decoration: none;

          color: #ffffff;
        }

        .sg-footer-logo-mark {
          position: relative;

          width: 42px;
          height: 42px;

          display: flex;

          align-items: center;
          justify-content: center;

          border: 2px solid rgba(255,255,255,0.88);

          border-radius: 9px;

          font-size: 18px;

          font-weight: 900;
        }

        .sg-footer-logo-mark::after {
          content: "";

          position: absolute;

          right: -4px;
          bottom: -4px;

          width: 11px;
          height: 11px;

          border-radius: 3px;

          background: #f39818;

          border: 2px solid #123b66;
        }

        .sg-footer-logo-name {
          display: block;

          color: #ffffff;

          font-size: 17px;

          font-weight: 900;

          letter-spacing: -0.3px;
        }

        .sg-footer-logo-sub {
          display: block;

          margin-top: 3px;

          color: rgba(255,255,255,0.48);

          font-size: 7.5px;

          font-weight: 700;

          letter-spacing: 1.1px;

          text-transform: uppercase;
        }

        .sg-footer-brand-text {
          margin: 22px 0 0;

          color: rgba(255,255,255,0.60);

          font-size: 11px;

          line-height: 1.8;
        }

        .sg-footer-brand-highlight {
          display: flex;

          align-items: center;

          gap: 8px;

          margin-top: 18px;

          color: rgba(255,255,255,0.65);

          font-size: 9px;

          line-height: 1.5;
        }

        .sg-footer-brand-highlight svg {
          flex-shrink: 0;

          color: #f7a62c;

          font-size: 14px;
        }

        /* =====================================================
           SOCIAL
        ===================================================== */

        .sg-footer-socials {
          display: flex;

          gap: 8px;

          margin-top: 24px;
        }

        .sg-footer-social {
          width: 35px;
          height: 35px;

          display: flex;

          align-items: center;
          justify-content: center;

          border:
            1px solid rgba(255,255,255,0.14);

          border-radius: 8px;

          color: rgba(255,255,255,0.75);

          background:
            rgba(255,255,255,0.055);

          text-decoration: none;

          transition:
            background 0.25s ease,
            color 0.25s ease,
            transform 0.25s ease;
        }

        .sg-footer-social:hover {
          transform: translateY(-3px);

          color: #ffffff;

          background:
            rgba(255,255,255,0.13);
        }

        .sg-footer-social svg {
          width: 16px;
          height: 16px;

          stroke-width: 2;
        }

        /* =====================================================
           FOOTER COLUMNS
        ===================================================== */

        .sg-footer-column-title {
          position: relative;

          margin: 0 0 20px;

          padding-bottom: 10px;

          color: #ffffff;

          font-size: 11px;

          font-weight: 800;

          letter-spacing: 0.8px;

          text-transform: uppercase;
        }

        .sg-footer-column-title::after {
          content: "";

          position: absolute;

          left: 0;
          bottom: 0;

          width: 25px;
          height: 2px;

          background: #f7a62c;

          border-radius: 5px;
        }

        .sg-footer-links {
          display: flex;

          flex-direction: column;

          gap: 11px;

          margin: 0;

          padding: 0;

          list-style: none;
        }

        .sg-footer-links a {
          display: inline-flex;

          align-items: center;

          gap: 7px;

          color: rgba(255,255,255,0.55);

          text-decoration: none;

          font-size: 10px;

          line-height: 1.45;

          transition:
            color 0.2s ease,
            transform 0.2s ease;
        }

        .sg-footer-links a:hover {
          color: #ffffff;

          transform: translateX(3px);
        }

        .sg-footer-link-icon {
          width: 12px;
          height: 12px;

          flex-shrink: 0;

          opacity: 0;

          color: #f39818;

          transform: translateX(-4px);

          transition:
            opacity 0.2s ease,
            transform 0.2s ease;
        }

        .sg-footer-links a:hover .sg-footer-link-icon {
          opacity: 1;

          transform: translateX(0);
        }

        /* =====================================================
           CAPABILITIES GRID
        ===================================================== */

        .sg-footer-capabilities {
          display: grid;

          grid-template-columns: 1fr 1fr;

          gap: 8px 12px;
        }

        .sg-footer-capability {
          display: flex;

          align-items: flex-start;

          gap: 7px;

          color: rgba(255,255,255,0.52);

          font-size: 9px;

          line-height: 1.45;
        }

        .sg-footer-capability svg {
          flex-shrink: 0;

          margin-top: 1px;

          color: #8fc1ff;

          font-size: 10px;
        }

        /* =====================================================
           CONTACT
        ===================================================== */

        .sg-footer-contact-list {
          display: flex;

          flex-direction: column;

          gap: 17px;
        }

        .sg-footer-contact {
          display: flex;

          align-items: flex-start;

          gap: 11px;
        }

        .sg-footer-contact-icon {
          width: 32px;
          height: 32px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 7px;

          color: #ffffff;

          background:
            rgba(255,255,255,0.08);

          font-size: 12px;
        }

        .sg-footer-contact-icon svg {
          width: 15px;
          height: 15px;

          stroke-width: 2;
        }

        .sg-footer-contact strong {
          display: block;

          margin-bottom: 4px;

          color: #ffffff;

          font-size: 9px;

          font-weight: 800;
        }

        .sg-footer-contact a,
        .sg-footer-contact span {
          color: rgba(255,255,255,0.52);

          font-size: 9px;

          line-height: 1.5;

          text-decoration: none;
        }

        .sg-footer-contact a:hover {
          color: #ffffff;
        }

        /* =====================================================
           CSI MINI SECTION
        ===================================================== */

        .sg-footer-csi {
          margin-top: 28px;

          padding-top: 20px;

          border-top:
            1px solid rgba(255,255,255,0.08);
        }

        .sg-footer-csi-title {
          margin-bottom: 12px;

          color: rgba(255,255,255,0.65);

          font-size: 8px;

          font-weight: 800;

          letter-spacing: 1px;

          text-transform: uppercase;
        }

        .sg-footer-csi-list {
          display: flex;

          flex-wrap: wrap;

          gap: 6px;
        }

        .sg-footer-csi-tag {
          padding: 5px 7px;

          border:
            1px solid rgba(255,255,255,0.09);

          border-radius: 5px;

          color: rgba(255,255,255,0.42);

          background:
            rgba(255,255,255,0.025);

          font-size: 7px;
        }

        /* =====================================================
           BOTTOM BAR
        ===================================================== */

        .sg-footer-bottom {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 25px;

          padding: 21px 0;

          border-top:
            1px solid rgba(255,255,255,0.10);

          opacity: 0;

          transform: translateY(15px);

          transition:
            opacity 0.7s ease 0.22s,
            transform 0.7s ease 0.22s;
        }

        .sg-footer-bottom.visible {
          opacity: 1;

          transform: translateY(0);
        }

        .sg-footer-copyright {
          color: rgba(255,255,255,0.40);

          font-size: 8.5px;
        }

        .sg-footer-legal {
          display: flex;

          align-items: center;

          gap: 20px;
        }

        .sg-footer-legal a {
          color: rgba(255,255,255,0.40);

          text-decoration: none;

          font-size: 8.5px;

          transition: color 0.2s ease;
        }

        .sg-footer-legal a:hover {
          color: #ffffff;
        }

        /* =====================================================
           BACK TO TOP
        ===================================================== */

        .sg-footer-top {
          width: 35px;
          height: 35px;

          display: flex;

          align-items: center;
          justify-content: center;

          border:
            1px solid rgba(255,255,255,0.14);

          border-radius: 8px;

          color: #ffffff;

          background:
            rgba(255,255,255,0.05);

          cursor: pointer;

          transition:
            background 0.25s ease,
            transform 0.25s ease;
        }

        .sg-footer-top:hover {
          transform: translateY(-3px);

          background:
            rgba(255,255,255,0.13);
        }

        .sg-footer-top svg {
          width: 16px;
          height: 16px;

          stroke-width: 2.2;
        }

        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1100px) {

          .sg-footer-main {
            grid-template-columns:
              1fr 1fr;

            gap: 45px;
          }

          .sg-footer-brand {
            max-width: 430px;
          }
        }

        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 760px) {

          .sg-footer-cta {
            display: block;

            padding: 55px 0;

            text-align: center;
          }

          .sg-footer-cta-label {
            justify-content: center;
          }

          .sg-footer-cta-text {
            margin-left: auto;

            margin-right: auto;
          }

          .sg-footer-cta-button {
            width: 100%;

            margin-top: 24px;
          }

          .sg-footer-main {
            grid-template-columns: 1fr;

            gap: 38px;

            padding: 50px 0;
          }

          .sg-footer-brand {
            max-width: 550px;
          }

          .sg-footer-capabilities {
            grid-template-columns: 1fr 1fr;
          }

          .sg-footer-bottom {
            display: block;

            text-align: center;
          }

          .sg-footer-legal {
            justify-content: center;

            margin-top: 13px;
          }

          .sg-footer-top {
            margin: 18px auto 0;
          }
        }

        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 480px) {

          .sg-footer-cta-title {
            font-size: 30px;

            letter-spacing: -1px;
          }

          .sg-footer-main {
            gap: 35px;
          }

          .sg-footer-capabilities {
            grid-template-columns: 1fr;
          }

          .sg-footer-legal {
            gap: 13px;
          }

          .sg-footer-csi-tag {
            font-size: 6.5px;
          }
        }

      `}</style>

      <footer
        className="sg-footer"
        ref={footerRef}
      >

        {/* =================================================
            BACKGROUND
        ================================================= */}

        <div className="sg-footer-blueprint"></div>

        <div className="sg-footer-circle-one"></div>

        <div className="sg-footer-circle-two"></div>


        <div className="sg-footer-container">

          {/* =================================================
              CTA
          ================================================= */}

          <div
            className={`sg-footer-cta ${
              visible ? "visible" : ""
            }`}
          >

            <div>

              <div className="sg-footer-cta-label">

                <span className="sg-footer-cta-dot"></span>

                Engineering • Estimating • Construction Support

              </div>

              <h2 className="sg-footer-cta-title">

                Build with better
                <span> project intelligence.</span>

              </h2>

              <p className="sg-footer-cta-text">

                From pre-construction planning and estimating to
                structural engineering, BIM coordination, and
                project engineering support, StructGuard helps
                construction teams move projects forward with
                accurate technical information.

              </p>

            </div>


            <a
              href="#Contact"
              className="sg-footer-cta-button"
            >

              DISCUSS YOUR PROJECT

              <span>
                <FiArrowUpRight />
              </span>

            </a>

          </div>


          {/* =================================================
              MAIN FOOTER
          ================================================= */}

          <div
            className={`sg-footer-main ${
              visible ? "visible" : ""
            }`}
          >

            {/* =================================================
                BRAND
            ================================================= */}

            <div className="sg-footer-brand">

              <a
                href="#home"
                className="sg-footer-logo"
              >

                <div className="sg-footer-logo-mark">
                  SG
                </div>

                <div>

                  <span className="sg-footer-logo-name">
                    StructGuard
                  </span>

                  <span className="sg-footer-logo-sub">
                    Construction Services LLP
                  </span>

                </div>

              </a>


              <p className="sg-footer-brand-text">

                Integrated construction services supporting
                pre-construction, estimating, structural
                engineering, BIM, project engineering, and
                construction coordination.

              </p>


              <div className="sg-footer-brand-highlight">

                <FiCheckCircle />

                <span>
                  Technical support built around accuracy,
                  coordination, and dependable project delivery.
                </span>

              </div>


              <div className="sg-footer-socials">

                <a
                  href="#"
                  className="sg-footer-social"
                  aria-label="LinkedIn"
                >
                  <FiLinkedin />
                </a>

                <a
                  href="#"
                  className="sg-footer-social"
                  aria-label="Facebook"
                >
                  <FiFacebook />
                </a>

                <a
                  href="#"
                  className="sg-footer-social"
                  aria-label="Instagram"
                >
                  <FiInstagram />
                </a>

              </div>

            </div>


            {/* =================================================
                NAVIGATION
            ================================================= */}

            <div>

              <h3 className="sg-footer-column-title">
                Navigation
              </h3>

              <ul className="sg-footer-links">

                {navigation.map((item) => (

                  <li key={item.name}>

                    <a href={item.href}>

                      <FiChevronRight
                        className="sg-footer-link-icon"
                      />

                      {item.name}

                    </a>

                  </li>

                ))}

              </ul>

            </div>


            {/* =================================================
                SERVICES
            ================================================= */}

            <div>

              <h3 className="sg-footer-column-title">
                Core Services
              </h3>

              <ul className="sg-footer-links">

                {services.map((service) => (

                  <li key={service.name}>

                    <a href={service.href}>

                      <FiChevronRight
                        className="sg-footer-link-icon"
                      />

                      {service.name}

                    </a>

                  </li>

                ))}

              </ul>


              {/* <div className="sg-footer-csi">

                <div className="sg-footer-csi-title">
                  Selected CSI Coverage
                </div>

                <div className="sg-footer-csi-list">

                  {divisions.slice(0, 6).map(
                    (division) => {

                      const [number] =
                        division.split(" — ");

                      return (
                        <span
                          className="sg-footer-csi-tag"
                          key={division}
                        >
                          {number}
                        </span>
                      );

                    }
                  )}

                </div>

              </div> */}

            </div>


            {/* =================================================
                CONTACT + CAPABILITIES
            ================================================= */}

            <div>

              <h3 className="sg-footer-column-title">
                Contact
              </h3>

              <div className="sg-footer-contact-list">

                <div className="sg-footer-contact">

                  <div className="sg-footer-contact-icon">
                    <FiMail />
                  </div>

                  <div>

                    <strong>
                      Email
                    </strong>

                    <a href="mailto:estimates@structguard.co.in">
                      estimates@structguard.co.in
                    </a>

                  </div>

                </div>


                <div className="sg-footer-contact">

                  <div className="sg-footer-contact-icon">
                    <FiPhone />
                  </div>

                  <div>

                    <strong>
                      Phone
                    </strong>

                    <a href="tel:+10000000000">
                      +1 (000) 000-0000
                    </a>

                  </div>

                </div>


                <div className="sg-footer-contact">

                  <div className="sg-footer-contact-icon">
                    <FiClock />
                  </div>

                  <div>

                    <strong>
                      Project Support
                    </strong>

                    <span>
                      Project-based technical support
                    </span>

                  </div>

                </div>

              </div>


              {/* <div className="sg-footer-csi">

                <div className="sg-footer-csi-title">
                  Key Capabilities
                </div>

                <div className="sg-footer-capabilities">

                  {capabilities.map(
                    (capability) => (

                      <div
                        className="sg-footer-capability"
                        key={capability}
                      >

                        <FiCheckCircle />

                        <span>
                          {capability}
                        </span>

                      </div>

                    )
                  )}

                </div>

              </div> */}

            </div>

          </div>


          {/* =================================================
              BOTTOM
          ================================================= */}

          <div
            className={`sg-footer-bottom ${
              visible ? "visible" : ""
            }`}
          >

            <div className="sg-footer-copyright">

              © {new Date().getFullYear()} StructGuard
              Construction Services LLP. All rights reserved.

            </div>


            <div className="sg-footer-legal">

              <a href="#">
                Privacy Policy
              </a>

              <a href="#">
                Terms & Conditions
              </a>

              <button
                className="sg-footer-top"
                onClick={scrollToTop}
                aria-label="Back to top"
              >

                <FiArrowUp />

              </button>

            </div>

          </div>

        </div>

      </footer>
    </>
  );
};

export default Footer;

